import { PricingSetFragment } from '@graphql/platform';

import { Commitment } from '@root/resources/types/commitment';
import { PlanName } from '@root/resources/types/plan_name';

import { usePricingSetForZIP } from '../pricing';
import { PricingSummary, usePricingSummary } from './use_pricing_summary';

type StoragePricingValues = {
  pricingSet?: PricingSetFragment;
  pricingSummary?: PricingSummary;
  defaultPricingSummary?: PricingSummary;
};

export const useStoragePricingValues = (
  zip?: string,
  commitment?: Commitment,
  planSize?: PlanName,
  options?: { defaultPlanSize?: PlanName },
): StoragePricingValues => {
  const pricingSet = usePricingSetForZIP(zip) ?? undefined;
  const fallbackPlanSize = options?.defaultPlanSize ?? '5x5';
  const pricingSummary =
    usePricingSummary({
      pricingSet,
      zip,
      commitment,
      planSize,
    }) ?? undefined;
  const defaultPricingSummary =
    usePricingSummary({
      pricingSet,
      zip,
      commitment,
      planSize: planSize ? undefined : fallbackPlanSize,
    }) ?? undefined;

  return {
    pricingSet: pricingSet,
    pricingSummary: pricingSummary,
    defaultPricingSummary: defaultPricingSummary,
  };
};
